// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"8e085fa1-168":"d675bee5a37311351567","8e085fa1-452":"5b5712905faeff29c0b0","8e085fa1-379":"dcc7320b90905abb5471","8e085fa1-83":"60ee5d316c1d9ddfd622"}[chunkId] + ".js";
};